import { IDeleteReportAction } from './deleteReport.interface';

export enum DeleteReportTypes {
  DELETE_REPORT = 'DELETE_REPORT',
}

export type DeleteReportAction = IDeleteReportAction;
